"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EternalPunishmentAbilityHandler = exports.EternalPunishmentActorAbilityFactory = exports.EternalPunishmentAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
class EternalPunishmentAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.EternalPunishment;
        this.__typeName = "EternalPunishment";
    }
}
exports.EternalPunishmentAbilityArgs = EternalPunishmentAbilityArgs;
let EternalPunishmentActorAbilityFactory = class EternalPunishmentActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("EternalPunishment", "AllEnemies", 2);
    }
};
EternalPunishmentActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("EternalPunishment")
], EternalPunishmentActorAbilityFactory);
exports.EternalPunishmentActorAbilityFactory = EternalPunishmentActorAbilityFactory;
let EternalPunishmentAbilityHandler = class EternalPunishmentAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            projectiles: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map(enemy => ({
                targetId: enemy,
                jitter: (0, Random_1.random)(50, 500),
                path: "line",
                type: "RedSunOrb",
                start: "head",
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 50)
                ],
            })),
            onHitOrMiss: (sequence, { hit }, { targetId }) => sequence.push(new core_2.InstantVfxStepArgs(hit ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "RedElectrifiedTornado")),
            onHit(sequence, attack, damage, projectile) {
                container.applyDebuff({
                    sequence: sequence,
                    attackerId: ability.invokerId,
                    targetId: projectile.targetId,
                    duration: Duration_1.Duration.Turns(5),
                    effect: new core_1.VulnerabilityEffectArgs(3),
                });
            }
        });
    }
};
EternalPunishmentAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.EternalPunishment)
], EternalPunishmentAbilityHandler);
exports.EternalPunishmentAbilityHandler = EternalPunishmentAbilityHandler;
